import digits from './digits';
import writtenDigits from './written-digits';

export default {
  digits,
  writtenDigits,
};



// WEBPACK FOOTER //
// ./src/js/filters/index.js